"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gerenzano": {
    "bea28a77": [{
      "hkey": "ab003347",
      "slug": "gerenzano",
      "name": "Gerenzano",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-grassina": [{
      "hkey": "ab003347",
      "slug": "gerenzano",
      "name": "Gerenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d10d8749": [{
      "hkey": "ab003347",
      "slug": "gerenzano",
      "name": "Gerenzano",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-laghetti": [{
      "hkey": "ab003347",
      "slug": "gerenzano",
      "name": "Gerenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "068d0d14": [{
      "hkey": "ab003347",
      "slug": "gerenzano",
      "name": "Gerenzano",
      "primary": true,
      "skipSearch": false
    }],
    "sorgente-san-giacomo": [{
      "hkey": "ab003347",
      "slug": "gerenzano",
      "name": "Gerenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;